// Copyright (c) Microsoft Corporation. All rights reserved.

import "../App.css"

import * as microsoftTeams from "@microsoft/teams-js"

import { useParams } from "react-router-dom"

type SampleAppConfigurationParams = {
  appName: string
}

// Provides configuration when sample is hosted in Teams.
const SampleAppConfiguration = () => {
  const { appName } = useParams<SampleAppConfigurationParams>()
  const settings = {
    entityId: appName,
    contentUrl: `${window.location.origin}/apps/${appName}`,
    suggestedTabName: "Spatial",
    websiteUrl: `${window.location.origin}`,
  }

  microsoftTeams.settings.setSettings(settings)
  microsoftTeams.settings.setValidityState(true)

  return (
    <div className="centered-container">
      <br />
      <p>Custom settings for app can go here</p>
      <br />

      <br />
      <br />
      <h3>Press save to continue</h3>
    </div>
  )
}

export default SampleAppConfiguration
